
import * as ESAS from './actions.js'

// define initial state of all possible properties
export const initialState = {
  error: false,
  loading: true,
  data: null,
  bannerData: [],
  bannerLoading: false
}

export default function reducer (state = initialState, action) {
  // modify state based on action types
  switch (action.type) {
    case ESAS.ESAS:
      return {
        ...state,
        loading: true,
        data: null
      }
    case ESAS.ESAS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data
      }
    case ESAS.ESAS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: null
      }
    case ESAS.ESAS_BANNER:
      return {
        ...state,
        bannerLoading: true,
        bannerData: []
      }
    case ESAS.ESAS_BANNER_SUCCESS:
      return {
        ...state,
        bannerLoading: false,
        bannerData: [ ...action.data ]
      }
    case ESAS.ESAS_BANNER_FAILURE:
      return {
        ...state,
        bannerLoading: false,
        error: { ...action.error },
        bannerData: []
      }
    default:
      return state
  }
}
